<template>
  <first-page>
    <sign-up-form/>
  </first-page>
</template>

<script>
import FirstPage from "@/components/pages/FirstPage";
import SignUpForm from "@/components/login/SignUpForm";

export default {
  name: "SignUpPage",
  components: {SignUpForm, FirstPage}
}
</script>

<style scoped>

</style>
